/**
 * Created by Ning Jiang on 2024-01-18.
 */

import {ElGordosRevengeLayers, Layers} from "../../view/ElGordosRevengeLayers";
import {ElGordosRevengeReelView} from "../../reels/ElGordosRevengeReelView";
import {ElGordosRevenge} from "../../ElGordosRevenge";
import {ReelStopPresentationController} from "../ReelStopPresentationController";
import {IReelStateEventData} from "../../../core/reel/ReelState";
import {ElGordosRevengeReelController} from "../../reels/ElGordosRevengeReelController";
import {TweenLite} from "gsap";

export class XBetView extends ReelStopPresentationController {

    private _left:PIXI.spine.Spine | null;
    private _right:PIXI.spine.Spine | null;
    private _isPlaying:boolean;
    private _featureCompleted:boolean = false;

    private _featureVisible:boolean;
    public set featureVisible(value:boolean) {
        this._featureVisible = value;
        this.updateView();
    }

    private _selectedIndex:number;
    public set selectedIndex(value:number) {
        this._selectedIndex = value;
        this.updateView();
    }

    constructor() {
        super('XBetView');
    }

    public updateView():void {
        if(!this._featureVisible || !this._selectedIndex || this._selectedIndex === 0) {
            if(this._left) {
                this._left.state.setEmptyAnimations(0);
                this._left.parent.removeChild(this._left);
                this._left.destroy();
                this._left = null;
            }
            if(this._right) {
                this._right.state.setEmptyAnimations(0);
                this._right.parent.removeChild(this._right);
                this._right.destroy();
                this._right = null;
            }
            this._isPlaying = false;
            return;
        }

        if(!this._left) {
            this._left = new PIXI.spine.Spine(ElGordosRevenge.assetLoader.getSpineAsset("xBetFrame"));
            this._left.autoUpdate = true;
            ElGordosRevengeLayers.getLayer(Layers.FOREGROUND_TOP)?.addChild(this._left);
            this._left.y = 626;
        }
        if(!this._right) {
            this._right = new PIXI.spine.Spine(ElGordosRevenge.assetLoader.getSpineAsset("xBetFrame"));
            this._right.autoUpdate = true;
            ElGordosRevengeLayers.getLayer(Layers.FOREGROUND_TOP)?.addChild(this._right);
            this._right.y = 626;
        }

        let leftEntry = this._left.state.getCurrent(0);
        if(leftEntry && leftEntry.animation.name === "left") {} else {
            leftEntry = this._left.state.setAnimation(0, "left", true);
            leftEntry.timeScale = 3;
        }

        let rightEntry = this._right.state.getCurrent(0);
        if(rightEntry && rightEntry.animation.name === "right") {} else {
            rightEntry = this._right.state.setAnimation(0, "right", true);
            rightEntry.timeScale = 3;
        }

        // this._left.visible = true;
        // this._right.visible = true;
        this._isPlaying = true;

        switch(this._selectedIndex) {
            case 1:
                this._left.x = ElGordosRevengeReelView.REEL_AREAS[1].x;
                this._right.x = ElGordosRevengeReelView.REEL_AREAS[1].x;
                return;
            case 2:
                this._left.x = ElGordosRevengeReelView.REEL_AREAS[1].x;
                this._right.x = ElGordosRevengeReelView.REEL_AREAS[4].x;
                return;
            case 3:
                this._left.x = ElGordosRevengeReelView.REEL_AREAS[1].x;
                this._right.x = ElGordosRevengeReelView.REEL_AREAS[4].x;
                return;
            case 4:
                this._left.x = ElGordosRevengeReelView.REEL_AREAS[1].x;
                this._right.x = ElGordosRevengeReelView.REEL_AREAS[4].x;
                return;
            default:
                debugger;
                return;
        }
    }

    protected onReelBounce(data:IReelStateEventData):Promise<any> {
        if(!this._isPlaying || data.reelId === 0 || data.reelId === 5 || this._featureCompleted) {
            return super.onReelBounce(data);
        }

        (<any>this)[`onXBet${this._selectedIndex}ReelStop`](data);

        return super.onReelBounce(data);
    }

    private onXBet1ReelStop(data:IReelStateEventData):void {
        if(data.reelId === 1) {
            this.hideAnimationOnReelStop();
        }
    }

    private onXBet2ReelStop(data:IReelStateEventData):void {
        if(data.reelId === 1) {
            if(this._left) {
                this._left.x = ElGordosRevengeReelView.REEL_AREAS[data.reelId + 1].x;
            }
            this.boostAnimationOnReelStop(1);
            return;
        }
        if(data.reelId === 2 || data.reelId === 3) {
            if(ElGordosRevenge.model.parsedGameData.S1Positions[data.reelId] > -1) {
                this.hideAnimationOnReelStop();
            } else {
                if(this._left) {
                    this._left.x = ElGordosRevengeReelView.REEL_AREAS[data.reelId + 1].x;
                }
            }
            return;
        }
        if(data.reelId === 4 && !this._featureCompleted) {
            this.hideAnimationOnReelStop();
        }
    }

    private onXBet3ReelStop(data:IReelStateEventData):void {
        if(data.reelId === 1) {
            if(this._left) {
                this._left.x = ElGordosRevengeReelView.REEL_AREAS[data.reelId + 1].x;
            }
            this.boostAnimationOnReelStop(1);
            return;
        }
        if(data.reelId === 2 || data.reelId === 3) {
            if(this.reelHasWXN(data.reelId)) {
                this.hideAnimationOnReelStop();
            } else {
                if(this._left) {
                    this._left.x = ElGordosRevengeReelView.REEL_AREAS[data.reelId + 1].x;
                }
            }
            return;
        }
        if(data.reelId === 4 && !this._featureCompleted) {
            this.hideAnimationOnReelStop();
        }
    }

    private onXBet4ReelStop(data:IReelStateEventData):void {
        if(data.reelId > 0 && data.reelId < 4) {
            if(this.reelHasWXN(data.reelId)) {
                this.hideAnimationOnReelStop();
            } else {
                if(this._left) {
                    this._left.x = ElGordosRevengeReelView.REEL_AREAS[data.reelId + 1].x;
                }
            }
            return;
        }
        if(data.reelId === 4 && !this._featureCompleted) {
            this.hideAnimationOnReelStop();
        }
    }

    private hideAnimationOnReelStop():void {
        this._featureCompleted = true;
        if(this._left) {
            this._left.state.setAnimation(0, "left_off", false);
        }
        if(this._right) {
            this._right.state.setAnimation(0, "right_off", false);
            // TweenLite.to(this, this._right.spineData.findAnimation("right_off").duration, {
            //     onComplete : () => {
            //         if(this._right)
            //             this._right.visible = false;
            //     }
            // });
        }
    }

    private boostAnimationOnReelStop(reelId:number):void {
        const boost = new PIXI.spine.Spine(ElGordosRevenge.assetLoader.getSpineAsset("xBetFrame"));
        boost.autoUpdate = true;
        ElGordosRevengeLayers.getLayer(Layers.FOREGROUND_TOP)?.addChild(boost);
        boost.x = ElGordosRevengeReelView.REEL_AREAS[reelId].x;
        boost.y = 626;
        boost.state.setAnimation(0, "boost", false);
        TweenLite.to(this, boost.spineData.findAnimation("boost").duration, {
            onComplete : () => {
                boost.state.setEmptyAnimations(0);
                boost.parent.removeChild(boost);
                boost.destroy();
            }
        });
    }

    private reelHasWXN(reelId:number):boolean {
        const reel = ElGordosRevenge.model.parsedGameData.reels[reelId].concat();
        const reelConfig = ElGordosRevengeReelController.SYMBOLS_NUM_IN_DATA[reelId];
        const checkRange:[number, number] = [reelConfig[1], reelConfig[1] + reelConfig[2]];
        for(let i:number = checkRange[0]; i < checkRange[1]; i++) {
            if(reel[i].includes("WXN")) {
                return true;
            }
        }
        return false;
    }

    protected reset():void {
        super.reset();
        this._featureCompleted = false;
    }

}